// Capa de fondo: rejilla, anillo cian giratorio a toda la página y orbes sutiles (poco neón).
export const BackgroundFX = () => {
  return (
    <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden bg-[#050505]">
      {/* Rejilla técnica */}
      <div className="grid-bg absolute inset-0" />

      {/* Anillo cian giratorio a toda la pantalla (misma animación del logo) */}
      <div
        className="spin-center absolute left-1/2 top-1/2 opacity-[0.18]"
        style={{
          width: "min(180vw, 180vh)",
          height: "min(180vw, 180vh)",
          borderRadius: "9999px",
          background:
            "conic-gradient(from 0deg, transparent 0deg, rgba(0,240,255,0.0) 180deg, rgba(0,240,255,0.5) 320deg, transparent 360deg)",
          maskImage:
            "radial-gradient(circle, transparent 48%, #000 50%, #000 64%, transparent 66%)",
          WebkitMaskImage:
            "radial-gradient(circle, transparent 48%, #000 50%, #000 64%, transparent 66%)",
          filter: "blur(2px)",
        }}
      />
      {/* Segundo anillo más amplio, giro inverso */}
      <div
        className="spin-slow-rev absolute left-1/2 top-1/2 opacity-[0.10]"
        style={{
          width: "min(240vw, 240vh)",
          height: "min(240vw, 240vh)",
          borderRadius: "9999px",
          background:
            "conic-gradient(from 120deg, transparent 0deg, rgba(59,130,246,0.0) 200deg, rgba(0,240,255,0.4) 300deg, transparent 360deg)",
          maskImage:
            "radial-gradient(circle, transparent 60%, #000 62%, #000 72%, transparent 74%)",
          WebkitMaskImage:
            "radial-gradient(circle, transparent 60%, #000 62%, #000 72%, transparent 74%)",
          filter: "blur(3px)",
        }}
      />

      {/* Orbe cian sutil arriba */}
      <div
        className="absolute -top-40 left-1/2 h-[60vw] max-h-[520px] w-[60vw] max-w-[520px] -translate-x-1/2 rounded-full opacity-[0.10] blur-[120px]"
        style={{ background: "radial-gradient(circle, #00F0FF, transparent 70%)" }}
      />
      {/* Orbe frío abajo izquierda */}
      <div
        className="absolute bottom-[-10%] left-[-5%] h-[50vw] max-h-[420px] w-[50vw] max-w-[420px] rounded-full opacity-[0.06] blur-[120px]"
        style={{ background: "radial-gradient(circle, #3b82f6, transparent 70%)" }}
      />

      {/* Viñeta */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse 70% 60% at 50% 40%, transparent 40%, rgba(0,0,0,0.65) 100%)",
        }}
      />
    </div>
  );
};

export default BackgroundFX;
